"use client";

import { c as _c } from "react/compiler-runtime";
import type { CommunityMemberMinimal } from "@/entities/IProfile";
import { useAuth } from "@/components/auth/Auth";
import GroupCreateIdentitySelectedItems from "@/components/groups/page/create/config/GroupCreateIdentitySelectedItems";
import GroupCreateIdentitiesSearch from "@/components/groups/page/create/config/identities/select/GroupCreateIdentitiesSearch";
import { areEqualAddresses } from "@/helpers/Helpers";
export default function CreateWaveInlineGroupIdentities(t0) {
  const $ = _c(28);
  const {
    identities,
    onIdentitySelect,
    onRemove
  } = t0;
  const {
    connectedProfile
  } = useAuth();
  let currentUserIdentity;
  let selectedWallets;
  let t1;
  if ($[0] !== connectedProfile || $[1] !== identities) {
    selectedWallets = identities.map(_temp);
    currentUserIdentity = connectedProfile?.primary_wallet ? {
      profile_id: connectedProfile.id,
      handle: connectedProfile.handle,
      normalised_handle: connectedProfile.normalised_handle,
      primary_wallet: connectedProfile.primary_wallet,
      display: connectedProfile.display,
      tdh: connectedProfile.tdh,
      level: connectedProfile.level,
      cic_rating: connectedProfile.cic,
      wallet: connectedProfile.primary_wallet,
      pfp: connectedProfile.pfp
    } : null;
    t1 = !!currentUserIdentity && selectedWallets.some(wallet => areEqualAddresses(wallet, currentUserIdentity.wallet));
    $[0] = connectedProfile;
    $[1] = identities;
    $[2] = currentUserIdentity;
    $[3] = selectedWallets;
    $[4] = t1;
  } else {
    currentUserIdentity = $[2];
    selectedWallets = $[3];
    t1 = $[4];
  }
  const isCurrentUserSelected = t1;
  const identitiesHelperText = identities.length === 0 ? "Add identities one by one to create a group." : null;
  const showHelperRow = !!identitiesHelperText || !!currentUserIdentity;
  let t2;
  if ($[5] !== currentUserIdentity || $[6] !== isCurrentUserSelected || $[7] !== onIdentitySelect || $[8] !== onRemove) {
    t2 = checked => {
      if (!currentUserIdentity) {
        return;
      }
      if (checked) {
        if (!isCurrentUserSelected) {
          onIdentitySelect(currentUserIdentity);
        }
        return;
      }
      if (isCurrentUserSelected) {
        onRemove(currentUserIdentity.wallet);
      }
    };
    $[5] = currentUserIdentity;
    $[6] = isCurrentUserSelected;
    $[7] = onIdentitySelect;
    $[8] = onRemove;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const onCurrentUserToggle = t2;
  let t3;
  if ($[10] !== onIdentitySelect || $[11] !== selectedWallets) {
    t3 = <GroupCreateIdentitiesSearch selectedWallets={selectedWallets} onIdentitySelect={onIdentitySelect} placeholder="Search identities..." hideLabel={true} inputClassName="tw-border-white/5 tw-bg-iron-950 tw-ring-white/5 hover:tw-ring-white/10 focus:tw-border-primary-400 focus:tw-bg-iron-950 focus:tw-ring-primary-400" iconClassName="tw-top-3.5 tw-text-iron-500" />;
    $[10] = onIdentitySelect;
    $[11] = selectedWallets;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== currentUserIdentity || $[14] !== identitiesHelperText || $[15] !== isCurrentUserSelected || $[16] !== onCurrentUserToggle || $[17] !== showHelperRow) {
    t4 = showHelperRow && <div className={`tw-flex tw-flex-wrap tw-items-center tw-gap-3 tw-px-1 ${identitiesHelperText ? "tw-justify-between" : "tw-justify-end"}`}>{identitiesHelperText && <p className="tw-mb-0 tw-text-sm tw-font-normal tw-leading-relaxed tw-text-iron-500">{identitiesHelperText}</p>}{currentUserIdentity && <label className="tw-inline-flex tw-cursor-pointer tw-items-center tw-gap-x-2 sm:tw-gap-x-3"><span className="tw-text-xs tw-font-semibold tw-text-iron-50">Include me</span><span className={`tw-rounded-full tw-bg-gradient-to-b tw-p-[1px] ${isCurrentUserSelected ? "tw-from-primary-300" : "tw-from-iron-600"}`}><input type="checkbox" role="switch" checked={isCurrentUserSelected} onChange={event => onCurrentUserToggle(event.target.checked)} className="tw-peer tw-sr-only" /><span aria-hidden="true" className={`tw-relative tw-flex tw-h-5 tw-w-9 tw-flex-shrink-0 tw-items-center tw-rounded-full tw-border-2 tw-border-transparent tw-p-0 tw-transition-colors tw-duration-200 tw-ease-in-out peer-focus-visible:tw-ring-2 peer-focus-visible:tw-ring-primary-500 peer-focus-visible:tw-ring-offset-2 ${isCurrentUserSelected ? "tw-bg-primary-500" : "tw-bg-iron-700"}`}><span className={`tw-pointer-events-none tw-inline-block tw-size-4 tw-transform tw-rounded-full tw-bg-iron-50 tw-shadow tw-ring-0 tw-transition tw-duration-200 tw-ease-in-out ${isCurrentUserSelected ? "tw-translate-x-[18px]" : "tw-translate-x-0"}`} /></span></span></label>}</div>;
    $[13] = currentUserIdentity;
    $[14] = identitiesHelperText;
    $[15] = isCurrentUserSelected;
    $[16] = onCurrentUserToggle;
    $[17] = showHelperRow;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  let t5;
  if ($[19] !== t3 || $[20] !== t4) {
    t5 = <div className="tw-space-y-4">{t3}{t4}</div>;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] !== identities || $[23] !== onRemove) {
    t6 = identities.length > 0 && <GroupCreateIdentitySelectedItems selectedIdentities={[...identities]} onRemove={onRemove} variant="inline" />;
    $[22] = identities;
    $[23] = onRemove;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== t5 || $[26] !== t6) {
    t7 = <div className="tw-space-y-5">{t5}{t6}</div>;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  return t7;
}
function _temp(identity) {
  return identity.wallet;
}